import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();

    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "45px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "14.4%"
      },
      {
        label: {
          value: "Description",
          size: "108px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        size: "26.7%",
        readOnly: true
      },
      {
        label: {
          value: "Line",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "lineCode"
        },
        size: "8.6%",
        readOnly: true
      },
      {
        label: {
          value: "Alt Line",
          size: "68px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "altLineCode"
        },
        size: "10.85%",
        readOnly: true
      },
      {
        label: {
          value: "Part",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "partNumber"
        },
        size: "9.1%",
        readOnly: true
      },
      {
        label: {
          value: "Alt Part",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "altPartNumber"
        },
        size: "12.1%",
        readOnly: true
      },
      {
        label: {
          value: "Supercede Part",
          size: "auto",
          fontSize: "95%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "shortDescription"
        },
        size: "18.2%",
        readOnly: true
      },
      {
        label: {
          value: "PM",
          size: "45px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "ic"
        },
        size: "7.2%",
        readOnly: true
      },
      {
        label: {
          value: "BG",
          size: "45px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "buyerGroup"
        },
        size: "7.2%",
        readOnly: true
      },
      {
        label: {
          value: "Relative Item",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "relativeItem"
        },
        size: "17.65%",
        readOnly: true
      },
      {
        label: {
          value: "Sub Line Code",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "subLineCode"
        },
        size: "17.65%",
        readOnly: true
      },
      {
        label: {
          value: "Size",
          size: "68px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemSize"
        },
        size: "13.85%",
        readOnly: true
      },
      {
        label: {
          value: "Unit of Measure",
          size: "188px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "unitOfMeasure"
        },
        size: "18.2%",
        readOnly: true
      },
      {
        label: {
          value: "Oil Gallons",
          size: "120px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "oilGallons"
        },
        size: "18.2%",
        readOnly: true
      },
      {
        label: {
          value: "Buyer 6 Category",
          size: "141px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "categoryCode"
        },
        size: "22.5%",
        readOnly: true
      },
      {
        label: {
          value: "Commercial Pop Code",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "commPop"
        },
        size: "18.5%",
        readOnly: true
      },
      {
        label: {
          value: "Pending Department",
          size: "184px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "pendingDept"
        },
        size: "31.7%",
        readOnly: true
      },
      {
        label: {
          value: "Date",
          size: "66px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "pendingDate"
        },
        size: "9.05%",
        readOnly: true
      },
      {
        label: {
          value: "Department",
          size: "120px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "majorDept"
        },
        size: "18.2%",
        readOnly: true
      },

      {
        label: {
          value: "Store Order Pack",
          size: "141px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "orderPack"
        },
        size: "22.5%",
        readOnly: true
      },
      {
        label: {
          value: "Case Flag",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "caseIndicatorFlag"
        },
        size: "13.15%",
        readOnly: true
      },
      {
        label: {
          value: "EAS Item",
          size: "auto",
          fontSize: "85%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "easItem"
        },
        size: "14.05%",
        readOnly: true
      },
      {
        label: {
          value: "Store Credit Flag",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "storeCreditFlag"
        },
        size: "13.9%",
        readOnly: true
      },
      {
        label: {
          value: "Ship Round Factor",
          size: "187px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "shipRoundFactor"
        },
        size: "18.15%",
        readOnly: true
      },
      {
        label: {
          value: "Cubic Inches",
          size: "120px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "unitCubicMeasure"
        },
        size: "18.2%",
        readOnly: true
      },
      {
        label: {
          value: "Item Weight",
          size: "141px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "weight"
        },
        size: "22.5%",
        readOnly: true
      },
      {
        label: {
          value: "Item Availability",
          size: "175px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendDist"
        },
        size: "18.6%",
        readOnly: true
      },

      {
        label: {
          value: "Personal Warranty",
          size: "184px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "warranty"
        },
        size: "18.7%",
        readOnly: true
      },
      {
        label: {
          value: "Warranty Months",
          size: "172px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "warrantyMonths"
        },
        size: "17.85%",
        readOnly: true
      },
      {
        label: {
          value: "Employee Discount",
          size: "175px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "discountable"
        },
        size: "22.3%",
        readOnly: true
      },
      {
        label: {
          value: "Multi Return Labels",
          size: "141px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "multiReturnLbls"
        },
        size: "22.5%",
        readOnly: true
      },
      {
        label: {
          value: "Supply Guide: Store",
          size: "175px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "storeSupplyGuide"
        },
        size: "18.6%",
        readOnly: true
      },
      {
        label: {
          value: "DC",
          size: "44.25px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "dcSuppGuide"
        },
        size: "8.6%",
        readOnly: true
      },
      {
        label: {
          value: "Fixture",
          size: "69px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "fixtureSuppGuide"
        },
        size: "10.1%",
        readOnly: true
      },
      {
        label: {
          value: "Store Inventory Control",
          size: "172px",
          fontSize: "96%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "storeInvCtl"
        },
        size: "17.85%",
        readOnly: true
      },
      {
        label: {
          value: "Force Quantity",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "qtyForce"
        },
        size: "149px",
        readOnly: true
      },
      {
        label: {
          value: "Stocking Level",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "stockMMultiple"
        },
        size: "149px",
        readOnly: true
      },
      {
        label: {
          value: "Register Code",
          size: "141px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "pkgLabel"
        },
        size: "14.4%",
        readOnly: true
      },
      {
        label: {
          value: "Custom Ind",
          size: "108px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "customCode"
        },
        size: "17.65%",
        readOnly: true
      },
      {
        label: {
          value: "Retail Profile Code",
          size: "165px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "retlProfile"
        },
        size: "17.65%",
        readOnly: true
      },
      {
        label: {
          value: "Max Per Car",
          size: "134px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "maxPerCar"
        },
        size: "13.9%",
        readOnly: true
      },
      {
        label: {
          value: "Supply Code",
          size: "121px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "supplyCode"
        },
        size: "187px",
        readOnly: true
      },
      {
        label: {
          value: "Tax Code",
          size: "119px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "taxCode"
        },
        size: "149px",
        readOnly: true
      },
      {
        label: {
          value: "ADF",
          size: "118px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "adf"
        },
        size: "149px",
        readOnly: true
      },
      {
        label: {
          value: "Mich Label",
          size: "141px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "msiCode"
        },
        size: "14.4%",
        readOnly: true
      },
      {
        label: {
          value: "Harmonize Code",
          size: "194px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "harmonizeCode"
        },
        size: "21.25%",
        readOnly: true
      },
      {
        label: {
          value: "Harmonize Quantity",
          size: "188px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "harmonizedQty"
        },
        size: "19.25%",
        readOnly: true
      },
      {
        label: {
          value: "Intl Label",
          size: "117px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "intlLabel"
        },
        size: "22.8%",
        readOnly: true
      },
      {
        label: {
          value: "Change Date",
          size: "175px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "changeDate"
        },
        size: "22.3%",
        readOnly: true
      },
      {
        label: {
          value: ""
        },
        span: {
          value: "Product Special Handling Codes:",
          alignment: "flex-end",
          size: "100%"
        },
        item: {
          node: "onlySpan",
          value: "",
          intemName: "TAG"
        },
        size: "22.5%"
      },
      {
        label: {
          value: "Hazardous Code",
          size: "127px",
          fontSize: "94%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "hazardCode"
        },
        size: "13.1%",
        readOnly: true
      },
      {
        label: {
          value: "Disposal Code",
          size: "117px",
          fontSize: "99%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "disposableCode"
        },
        size: "14.15%",
        readOnly: true
      },
      {
        label: {
          value: "MSDS Date",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "msdsDate"
        },
        size: "13.9%",
        readOnly: true
      },
      {
        label: {
          value: "Flammable Code",
          size: "187px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "flammableCode"
        },
        size: "18.15%",
        readOnly: true
      },
      {
        label: {
          value: "Recycle Code",
          size: "120px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "recycleCode"
        },
        size: "18.2%",
        readOnly: true
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  getTheJson = () => {
    for (let index = 0; index < this.headerLayout.length; index++) {
    }
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
